import el from "@cypherpotato/el";
import { getUniqueColor } from "../ui/unique-color";

export function Badge(text, color, ...args) {
    return el("span.badge", text, { style: { backgroundColor: color || getUniqueColor(text) } }, ...args);
}

export function TagBadge(text, ...args) {
    return el("span.tag-badge", text, ...args);
}

export function BadgeList(...args) {
    return el("span.badge-list", ...args);
}